import { ReactNodeViewRenderer, Node, mergeAttributes } from '@tiptap/react'
import { Component } from './component'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		divider: {
			setDivider: () => ReturnType
		}
	}
}

export const Divider = Node.create({
	name: 'divider',

	isolating: true,

	content: 'block*',

	defining: true,

	group: 'block',

	draggable: true,

	selectable: true,

	addAttributes() {
		return {
			spacing: {
				default: 16,
			},
			color: {
				default: '#F4F4F4',
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: 'hr',
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return [
			'hr',
			mergeAttributes(HTMLAttributes, {
				style: `margin-top: ${HTMLAttributes.spacing / 2}px; margin-bottom: ${HTMLAttributes.spacing / 2 + 16}px;`,
			}),
			0,
		]
	},

	addCommands() {
		return {
			setDivider:
				() =>
				({ commands }) =>
					commands.insertContent({
						type: 'divider',
					}),
		}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default Divider
